const encoder = new TextEncoder();
export default function mapStringToByteLength(value) {
    return encoder.encode(value).length;
}
//# sourceMappingURL=map-string-to-byte-length.js.map